import { Container, Row } from 'reactstrap';
import ColumnChart from '../../CustomComponent/Charts/ColumnChart';
import Breadcrumbs from '../../CommonElements/Breadcrumbs';
import { useUser } from '../../Contexts/UserContext';
import { useDashboardData } from '../../Hooks/useDashboardData';
import { getDashboardData } from '../../Services/ClientService';
import { useEffect } from 'react';

export default function ClientDashboard() {
    const { user } = useUser();
    const clientId = user?.client_id || '';
    const { electricityData, gasData, waterData, electricityGasData, totalProperties, totalMeters, electricityCostData, gasCostData, waterCostData } =
        useDashboardData(clientId, getDashboardData);

    useEffect(() => {
        if (clientId) {
            localStorage.setItem('selectedClient', clientId);
        }
    }, [clientId]);

    return (
        <>
            <Breadcrumbs pageTitle='Dashboard' />
            <Container className='default-dashboard' fluid>
                <Row>
                    {electricityData || gasData || waterData || (electricityGasData && gasData) ? (
                        <>
                            {electricityData && <ColumnChart title='Electricity' data={electricityData} height={250} />}
                            {gasData && <ColumnChart title='Gas' data={gasData} height={250} />}
                            {waterData && <ColumnChart title='Water' data={waterData} height={250} />}
                            {electricityGasData && gasData && <ColumnChart title='Electricity-Gas' data={electricityGasData} height={250} />}
                        </>
                    ) : (
                        <div style={{ width: '100%', height: '640px', textAlign: 'center' }}>No data available.</div>
                    )}
                </Row>
                <Row>
                    {electricityCostData || gasCostData || waterCostData ? (
                        <>
                            {electricityCostData && <ColumnChart title='Electricity Cost' data={electricityCostData} height={250} size={4} />}
                            {gasCostData && <ColumnChart title='Gas Cost' data={gasCostData} height={250} size={4}/>}
                            {waterCostData && <ColumnChart title='Water Cost' data={waterCostData} height={250} size={4}/>}
                        </>
                    ) : (
                        ''
                    )}
                </Row>
            </Container>
        </>
    );
}
